/** 
 * 企点自用登录逻辑
 */
import axios from 'axios';
import { IMSDK, SDK } from '../sdk';
import Domain from '../domain';
import { _log, _error } from './log';
import wpaBridge from '../../utils/wpaBridge';
import API from './api';
import { createAid, guid } from './aid.create';

const base64 = require('js-base64/base64.js');
// import { base64 } from '@tencent/qd-lib';


/**
 * 基础配置参数
 */
export interface InitConfig {
  
  /** 主号 */
  kfuin: number;
  /** 接待的id */
  wpaId?: string | number;
  
  /** @internal appid */
  appid?: number;
  /** @internal 通路类型 */
  channelType?: number;
  /** @internal 认证类型 */
  authType?: string;
  /** @internal 认证数据 */
  authData?: string;
  /** @internal wpa内部信息 */
  wpaDetail?: any;
}
 enum localStorageKey {
  aid = 'qdim_v5_user_id',
  token = 'qdim_v5_token',
  uuid = 'qdim_v5_uuid',
 }
// 保存或读取用户的id,token或者uuid。 id由server下发
function valueToLocalStorage(key: string = localStorageKey.aid, val?: string, ): string | void {
  const saveKey = key;
  
  if (val) {
    // 保存
    try {
      // try一下，防止苹果手机隐私模式时 localStorage 无效
      localStorage.setItem(saveKey, String(val));
    } catch (ex) { }
  } else {
    // 读取
    try {
      return localStorage.getItem(saveKey) || '';
    } catch (ex) {
      return '';
    }
  }
}


let requestTime = 0;
/**
 * @internal 获取visitorId以及token
 * @param wpaDetail 
 * @returns 
 */
export function getVisitorAndUuidAndToken(wpaDetail, storeKeys?) {
  // 支持更改key
  const stKey = storeKeys ? storeKeys : localStorageKey;
  // 在wpa中
  if(wpaBridge.inIframe()){
    // 使用wpa的aid
    if(wpaDetail.visitorid && (wpaDetail.uuid || wpaDetail.token)){
      console.log('wpaDetail', wpaDetail.visitorid, wpaDetail.uuid, wpaDetail.token);
      return {
        aid: wpaDetail.visitorid,
        uuid:!wpaDetail.token? wpaDetail.uuid : '',
        token: wpaDetail.token? wpaDetail.token : '',
      }
    }else{
      let aid = createAid();
      let uuid = guid();
      return {
        aid,
        uuid,
        token:'',
      }
    }
  }else{
    //不在wpa中
    let aid = valueToLocalStorage(stKey.aid);
    let uuid = valueToLocalStorage(stKey.uuid);
    let token = valueToLocalStorage(stKey.token);
    if(!aid || (!uuid && !token)){
      aid = createAid();
      uuid = guid();
      valueToLocalStorage(stKey.aid, aid);
      valueToLocalStorage(stKey.uuid, uuid);
      try{
        localStorage.removeItem(stKey.token);
      }catch(e){}
    }
    return {
      aid,
      uuid,
      token: valueToLocalStorage(stKey.token),
    }
  }
}

/**
 * @internal 更新本地存储的vid等信息
 */
export function updateLocalStorageVid(userConfig, storeKeys?) {
  // 支持更改key
  const stKey = storeKeys ? storeKeys : localStorageKey;
  const { aid, d2 } = userConfig;
  // 存储新的aid和token
  valueToLocalStorage(stKey.aid, aid);
  valueToLocalStorage(stKey.token, d2);
  
  // 有token了，删掉uuid
  try {
    localStorage.removeItem(stKey.uuid);
  } catch (e) { }
}

/**
 * @internal
 * @deprecated 已弃用。请使用 createVisitor + loginQDIM 组合实现
 * 初始化IM，进行登录连接。企点产品内部自用。请勿对外暴露。
 * @param config 初始化配置
 * @returns 
 */
export function initIM(config: InitConfig) {
  const { Instant } = window;
  if (!Instant) {
    _error('Instant must be loaded!');
  }
  
  const userConfig = getVisitorAndUuidAndToken(config.wpaDetail);
  requestTime++;
  const postData: any = {
    uint32_appid: config.appid || 3,
    uint64_kfuin: config.kfuin,
    // C侧请求使用的用户key。server根据这个值来确定C侧用户的aid
    // 如果有保存，则返回。否则发送空字符串。
    // 如果有 auth认证， 也传空
    bytes_custom_key: config.authType ? '' : base64.encode(String(userConfig.aid || '')),
    str_session_ticket: userConfig && userConfig.aid && userConfig.token? userConfig.token : '',
    str_client_uuid: userConfig && userConfig.aid && userConfig.uuid? userConfig.uuid : '',
  };

  // 如果是鉴权逻辑，就将所有参数base64编码后上传
  if (config.authType) {
    postData.str_auth_info = base64.encode(config.authData);
  }

  return new Promise((resolve, reject) => {
    // 获得内置域名
    const IM_DOMAIN = Domain.getSDKDomain();

    axios.post(IM_DOMAIN.api + API.LOGIN, postData).then(async(res) => {
      if (res.status === 200) {
        const { code, data } = res.data;
        if (code === 0 || (requestTime >= 4 && data && data.uint64_unique_id)) {
          requestTime = 0;
          
          const aid = data.uint64_unique_id;
          const skey = base64.decode(data.session_key);
          const d2 = base64.decode(data.session_ticket);
          const url = base64.decode(data.socket_address);
          // 鉴权信息
          const userInfo = data.bytes_str_user_info;

          if (aid && skey && d2) {
            // aid, 即 visitorId
            if(wpaBridge.inIframe()){
              config.wpaDetail.visitorid = aid;
              config.wpaDetail.token = d2;
              config.wpaDetail.uuid =  userConfig.uuid || '';
              //此处通知更新WPA。
              window.parent.postMessage({
                act:'UPDATE_AUTH',
                data: {
                  visitorid: aid,
                  token: d2,
                  kfuin: config.kfuin,
                  wpaId: config.wpaDetail.wpaId
                }
              }, '*');
            } else {
              // 存储新的aid和token
              updateLocalStorageVid({ aid, d2 });
            }
            const socketio = Instant.create({
              appid: 3, // 产品类型(向天机ST申请)
              client_type: 5, //
              kfuin: config.kfuin, // 主号,
              aid, // 工号
              skey: '', // 登录态，C侧传空
              d2, // IM消息系统校验token
              url: IM_DOMAIN.ws, // APEX网关地址
              token_type: 0, // 登录态类型，C侧值为0
            });

            socketio.ready().then((info) => {
              _log('Instant Ready', info);
            });

            const imsdk = IMSDK.create({
              socketio,
            }, {
              channelType: 4, // 私有化webim固定为4
            });

            // 登录，传入其他信息
            imsdk.login!(
              {
                uin: aid, // vid
                corpUin: config.kfuin, // 主号
              },
              {
                wpaId: config.wpaId, // wpaid
              },
            );

            const loginData = {
              aid, userInfo, d2, imsdk
            };

            _log('[im-create-succ]', aid);

            resolve(loginData);
          }
        } else {
          //当请求错误的时候删除当前的aid
          try{
            // 只有后端明确该用户不能正常使用时进行清除
            if(!wpaBridge.inIframe() && code === 10017){
              localStorage.removeItem(localStorageKey.aid);
              localStorage.removeItem(localStorageKey.token);
              localStorage.removeItem(localStorageKey.uuid);
            }
            if(wpaBridge.inIframe() && code === 10017) {
              config.wpaDetail.visitorid = '';
              config.wpaDetail.uuid = '';
              config.wpaDetail.token = '';
            }
          }catch(e){}
          //当重复的次数小于3次时候继续执行
          if(requestTime < 4){
            resolve( await initIM(config));
            return;
          }
          reject(new Error(res.data.message || '登录失败'));
        }
      } else {
        reject(new Error('登录失败'));
      }
    })
      .catch(() => {
        reject(new Error('登录失败'));
      });
  });
}


